// extracted by mini-css-extract-plugin
export default {"BookingInfo":"BookingInfo_BookingInfo__pErnW","Header":"BookingInfo_Header__UZ1ip"};